import axios from "axios";

// Use same-origin by default (best for nginx reverse proxy)
// Only allow https overrides (prevents accidental http mixed-content)
const envURL = process.env.REACT_APP_API_URL?.trim();
const baseURL = envURL && envURL.startsWith("https://") ? envURL : "";

// Create a dedicated instance
const api = axios.create({
  baseURL,
  withCredentials: true, // ok even if you don't use cookies
});

function emitApiEvent(name, detail) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(name, { detail }));
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status || 0;
    const message = error?.response?.data?.error || error?.message || "Request failed";
    const method = String(error?.config?.method || "get").toUpperCase();
    const url = error?.config?.url || "";
    const isAuthRoute = /\/api\/(auth\/)?(login|register|logout|me|profile)/.test(url);

    if (!error?.response) {
      emitApiEvent("app:api-error", {
        kind: "network",
        message: "Network connection lost. Your workspace is still open, but recent changes may not be saved.",
        method,
        url,
      });
    } else if (status === 401 && !isAuthRoute) {
      emitApiEvent("app:api-error", {
        kind: "auth",
        message: "Your session expired. Refresh the page and sign in again.",
        method,
        url,
      });
    } else if (status >= 500) {
      emitApiEvent("app:api-error", {
        kind: "server",
        message: "The server could not complete that request. Try again in a moment.",
        method,
        url,
      });
    } else if (["POST", "PUT", "PATCH", "DELETE"].includes(method) && !isAuthRoute) {
      emitApiEvent("app:api-error", {
        kind: "mutation",
        message,
        method,
        url,
      });
    }

    return Promise.reject(error);
  }
);

export default api;
